export default __webpack_public_path__ + "static/media/dropbox-icon.d5170df0.svg";